module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Medium.woff
// module id = 69
// module chunks = 8